export class UIDGiftingSceneController {
    hide() {
        this.giftingSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.giftingSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.giftingSceneContainerDiv = document.getElementById('scene_discord_gifting_container');
    }
}
